import React, { FC } from 'react';
import { useSelector } from 'react-redux';

// Shared UI Library Components
import { CustomIcon, EIconName, CustomTooltip } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './totals-block.scss';

// Store entities
import { getDashboardState } from '../../../../store/dashboard/dashboard.selectors';
import { getCurrencyState } from '../../../../store/currency/currency.selectors';

type TTotalsBlockProps = {};

export const TotalsBlock: FC<TTotalsBlockProps> = (
  {}: TTotalsBlockProps
) => {
  const { totals } = useSelector(getDashboardState);
  const { currentCurrency } = useSelector(getCurrencyState);

  const income_charts = totals?.income_charts || {
    audio_calls: 0,
    video_calls: 0,
    conversations: 0,
    paid_messages: 0,
  };
  const total_service_revenue = (income_charts?.audio_calls + income_charts?.video_calls + income_charts?.conversations + income_charts?.paid_messages);

  return (
    <div className="totals-block">
      <div className="totals-block--item">
        <div className="item-info">
          <div className="item-info--total">
            { totals?.total_counsellors ?? '0' }
          </div>
          <div className="item-info--title">
            Total Consultants
            <CustomTooltip title={ 'This metric shows the current number of active Consultants' }>
              <CustomIcon name={ EIconName.Info } size={ 'size-md' }/>
            </CustomTooltip>
          </div>
        </div>
        <div className="item-icon">
          <CustomIcon name={ EIconName.Counsellors } skipSize={ true }/>
        </div>
      </div>
      <div className="totals-block--item">
        <div className="item-info">
          <div className="item-info--total">
            { totals?.total_consultations ?? '0' }
          </div>
          <div className="item-info--title">
            Total Consultations
            <CustomTooltip title={ 'This metric shows the total number of all completed consultations' }>
              <CustomIcon name={ EIconName.Info } size={ 'size-md' }/>
            </CustomTooltip>
          </div>
        </div>
        <div className="item-icon">
          <CustomIcon name={ EIconName.Communication_fill } skipSize={ true }/>
        </div>
      </div>
      <div className="totals-block--item">
        <div className="item-info">
          <div className="item-info--total">
            { currentCurrency?.symbol ?? '' }{ total_service_revenue ?? '0' }
          </div>
          <div className="item-info--title">
            Total Service Revenue
            <CustomTooltip title={ 'This metric shows the total revenue, excluding refunds for unfulfilled services' }>
              <CustomIcon name={ EIconName.Info } size={ 'size-md' }/>
            </CustomTooltip>
          </div>
        </div>
        <div className="item-icon">
          <CustomIcon name={ EIconName.Wallet } skipSize={ true }/>
        </div>
      </div>
    </div>
  );
}
